import { graphql } from "@apollo/client/react/hoc";
import React from "react";
import styles from "./styles.scss";
import { withRouter, Link, RouteComponentProps } from "react-router-dom";
import Text from "components/LegacyText";
import missingProfileImgQuery from "./missingProfileImgQuery.gql";
import { User } from "interfaces/user";
import { useTranslation } from "react-i18next";
import { flowRight as compose } from "lodash";
interface Props extends RouteComponentProps {
  missingProfileImgQuery: {
    me: User;
  };
}

const MissingProfileImg = ({ missingProfileImgQuery, location }: Props) => {
  const { t } = useTranslation();
  if (!missingProfileImgQuery.me) {
    return null;
  }
  if (
    !missingProfileImgQuery.me.assets ||
    !missingProfileImgQuery.me.assets.find(a => a.assetType === "profile_image" && a.isPrimary)
  ) {
    return (
      <Text.P3 className={styles.banner} kind="reverse">
        <span>{t("gogetter.settings.missingProfileImage")} </span>
        <Link to="/settings/profile">Click here</Link>
        <span>.</span>
      </Text.P3>
    );
  }
  return null;
};

export default compose(
  withRouter,
  graphql(missingProfileImgQuery, { name: "missingProfileImgQuery" }),
)(MissingProfileImg);
